/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {searchSupportArticles} from '../api'

export const useMutationSearchSupportArticles = createReactQueryMutationHook('searchSupportArticles', searchSupportArticles)
